// Progressive-blur scrim: ::before + these six divs + ::after are the eight stacked
// backdrop-filter layers styled in the checkout stylesheet. Absolutely positioned, so it never
// contributes to the header/footer height useSummaryOverlaySpacing measures.
import './styles.scss';

export default function SummaryScrim() {
  return (
    <div className="checkout-summary-scrim" aria-hidden="true">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
